import React, { useRef, useState } from 'react'
import Flatpickr from 'react-flatpickr';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { CreatorsSortOptionLabel as SortOptionLabel, CreatorsSortOptions as SortOptions, SocialAccountCreatorsFilters } from 'types/social-account';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { setCreatorsFilters } from 'slices/socialAccounts/reducer';

const Filters: React.FC<{ justifyContent?: string }> = ({ justifyContent = 'end' }) => {
    const [flatpickr, setFlatPickr] = useState<boolean>(true)
    const filters = useSelector((state: RootState) => state.socialAccountState.creators.filters);
    const dispatch: AppDispatch = useDispatch();
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
    const [searchQuery, setSearchQuery] = useState('');

    const setFilters = (updatedFilters: SocialAccountCreatorsFilters) => {
        dispatch(setCreatorsFilters(updatedFilters));
    }

    const getSelectedDate = () => {
        const { start_date, end_date } = filters;
        const dates: Date[] = [];
        if (start_date) dates.push(moment(start_date, 'YYYY-MM-DD').toDate());
        if (end_date) dates.push(moment(end_date, 'YYYY-MM-DD').toDate());
        return dates;
    };

    const handleDateChange = (selectedDates: Date[]) => {
        if (selectedDates.length === 2) {
            setFilters({ ...filters, start_date: moment(selectedDates[0]).format('YYYY-MM-DD'), end_date: moment(selectedDates[1]).format('YYYY-MM-DD') })
        } else if (selectedDates.length === 1) {
            // handleFilterChange('end_date', '');
        } else {
            let updated_filters = { ...filters };
            delete updated_filters.start_date;
            delete updated_filters.end_date;
            setFilters(updated_filters);
        }
    };

    const searchTask = (q: string) => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            if (q.trim().length > 3) {
                setFilters({ ...filters, q: q.trim(), page: 1 });
            } else if (q.trim().length === 0) {
                setFilters({ ...filters, q: '', page: 1 });
            }
        }, 500);
        setSearchQuery(q);
    }


    return (
        <div className={`d-flex align-items-center gap-3 justify-content-${justifyContent}`}>
            <div className="position-relative">
                {
                    (filters.start_date || filters.end_date) &&
                    <button onClick={() => {
                        handleDateChange([])
                        setFlatPickr(false);
                        setTimeout(() => {
                            setFlatPickr(true)
                        }, 0)
                    }} className="unset-all text-primary cursor-pointer" style={{ fontSize: '12px', position: 'absolute', top: '6px', right: '6px' }}> <i className="mdi mdi-close fs-5 fw-bold"></i> </button>
                }
                {
                    flatpickr &&
                    <Flatpickr
                        className="border-0 dash-filter-picker filter-date-range performance-date-range-picker form-control"
                        options={{
                            mode: 'range',
                            dateFormat: 'd M, Y',
                        }}
                        style={{ width: '220px' }}
                        {...({ placeholder: "Select Date Range" } as any)}
                        value={getSelectedDate() as unknown as Date}
                        onChange={handleDateChange}
                    />
                }
            </div>
            {/* <div className="campaign-layout-search-container position-relative">
                <span>
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.66732 14.0002C11.1651 14.0002 14.0007 11.1646 14.0007 7.66683C14.0007 4.16903 11.1651 1.3335 7.66732 1.3335C4.16951 1.3335 1.33398 4.16903 1.33398 7.66683C1.33398 11.1646 4.16951 14.0002 7.66732 14.0002Z" fill="#BBD8ED" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M15 16L12 13" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </span>
                <input type="text" placeholder='Search...' value={searchQuery} onChange={(e) => searchTask(e.target.value)} className="campaign-layout-search-input" />
                {
                    searchQuery && (
                        <span className="search-clear-icon" onClick={() => {
                            searchTask('');
                        }}>
                            <i className='bx bx-x' />
                        </span>
                    )
                }
            </div> */}
            <UncontrolledDropdown className='sort-dropdown'>
                <DropdownToggle tag={"button"} className='btn btn-white d-flex justify-content-between align-items-center w-100'>
                    <span>
                        <span className='text-muted me-1'>Sort by: </span>
                        {SortOptionLabel[filters.sort as keyof typeof SortOptionLabel]}
                    </span>
                    <i className='mdi mdi-chevron-down fs-5' />
                </DropdownToggle>
                <DropdownMenu className='mt-1 p-0 w-100'>
                    {
                        Object.values(SortOptions).map((sortOption, i) => <DropdownItem key={i} onClick={() => setFilters({ ...filters, sort: sortOption })}>{SortOptionLabel[sortOption]}</DropdownItem>)
                    }
                </DropdownMenu>
            </UncontrolledDropdown>
        </div>
    )
}

export default Filters
